// Export bridge to maintain backward compatibility
import DLOLocationSetting from './DLOLocationSetting/index';
export default DLOLocationSetting;
